var backendHost;
var jasperHost;
var scaUrl;
var captchaHost;
var recepDocuHost;
var hostname = window && window.location && window.location.hostname;
var separacionhostname = hostname.split(".");
var dominioCapacitacion = hostname.split(".")[0];
separacionhostname.shift();
var currentdomain = separacionhostname.join(".");
var protocolomain = "".concat(window.location.protocol, "//");

if (currentdomain === "seps.gob.ec") {
  //pro
  console.log("El hostname: ", hostname);
  console.log("La url que valida: ", dominioCapacitacion);

  if (dominioCapacitacion === 'capacitacionsca') {
    console.log("Entra por caacitación");
    scaUrl = "https://capacitacionsca.seps.gob.ec";
    captchaHost = "https://captcha.seps.gob.ec";
    backendHost = "https://srvrestcap-app.seps.gob.ec";
    jasperHost = "https://capacitacion1.seps.gob.ec/jasperserver/rest_v2/reports/";
    recepDocuHost = "http://protecciondatos.seps.gob.ec";
  } else if (dominioCapacitacion === 'sistemas') {
    console.log("Entra por producción");
    scaUrl = "https://sistemas.seps.gob.ec";
    captchaHost = "https://captcha.seps.gob.ec";
    backendHost = "https://serviciosrest.seps.gob.ec";
    jasperHost = "https://servicios.seps.gob.ec/jasperserver/rest_v2/reports/";
    recepDocuHost = "https://protecciondatos.seps.gob.ec";
  }
} else if (currentdomain === "seps.local") {
  //pre
  scaUrl = "".concat(protocolomain, "sca.seps.local");
  captchaHost = "".concat(protocolomain, "captcha.seps.local");

  if (protocolomain === "https://") {
    backendHost = "https://srvrestpre-app.seps.gob.ec";
  } else {
    backendHost = "https://srvrestpre-app.seps.gob.ec";
  }

  jasperHost = "https://pre.seps.gob.ec/jasperserver/rest_v2/reports/";
  recepDocuHost = "http://protecciondatos.seps.local";
} else if (hostname === "localhost") {
  captchaHost = "http://captcha.seps.local";
  scaUrl = "http://localhost:4000";
  backendHost = "https://srvrestdesa-app.seps.gob.ec";
  jasperHost = "https://desarrollo.seps.gob.ec/jasperserver/rest_v2/reports/";
  recepDocuHost = "http://172.30.1.136:31822";
} else {
  captchaHost = "http://captcha.seps.local";
  scaUrl = "https://desappfront.seps.local";
  backendHost = "https://srvrestdesa-app.seps.gob.ec";
  jasperHost = "https://desarrollo.seps.gob.ec/jasperserver/rest_v2/reports/";
  recepDocuHost = "http://172.30.1.136:31822";
}

export var API_ROOT = "".concat(backendHost);
export var JASPER_ROOT = "".concat(jasperHost);
export var SCA_ROOT = "".concat(scaUrl);
export var CAPTCHA_HOST = "".concat(captchaHost);
export var API_RD = "".concat(recepDocuHost);